import { fetchHandler, HTTP_METHOD, limiter, API_VERSION_ESYMANDANT } from 'application/api/request_builders'
import { fetchRequestBuilder } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const deleteMarkFavoriteMessage = (accountId, messageId) => {
    const request = fetchRequestBuilder(`${API_VERSION_ESYMANDANT}/e.consult.${accountId}/messages/${messageId}/favorite`, HTTP_METHOD.DELETE)

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}